import { render, staticRenderFns } from "./jilu.vue?vue&type=template&id=dafe96bc&scoped=true"
import script from "./jilu.vue?vue&type=script&lang=js"
export * from "./jilu.vue?vue&type=script&lang=js"
import style0 from "./jilu.vue?vue&type=style&index=0&id=dafe96bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafe96bc",
  null
  
)

export default component.exports